import { useEffect, useState } from "react";
import Lenis from "lenis";
import Topbar from "./components/landing/Topbar";
import Hero from "./components/landing/Hero";
import Marquee from "./components/landing/Marquee";
import Testimonials from "./components/landing/Testimonials";
import Diferencia from "./components/landing/Diferencia";
import Programa from "./components/landing/Programa";
import Faq from "./components/landing/Faq";
import FinalCta from "./components/landing/FinalCta";
import CalendarSection from "./components/landing/CalendarSection";
import Footer from "./components/landing/Footer";
import Privacidad from "./components/landing/Privacidad";
import Terminos from "./components/landing/Terminos";

export default function App() {
    const [route, setRoute] = useState(window.location.hash);

    useEffect(() => {
        const p = window.location.pathname;
        if (p !== "/clasegratis" && !p.startsWith("/clasegratis/")) {
            window.history.replaceState(null, "", "/clasegratis" + window.location.hash);
        }
    }, []);

    useEffect(() => {
        const onHash = () => setRoute(window.location.hash);
        window.addEventListener("hashchange", onHash);
        return () => window.removeEventListener("hashchange", onHash);
    }, []);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        import("./vslgate");
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    const esLegal = route === "#/privacidad" || route === "#/terminos";

    return (
        <div className="grain min-h-screen bg-[#0d0d0d] text-[#f5f5f5]">
            <div style={esLegal ? { display: "none" } : undefined}>
                <Topbar />
            <main>
                <Hero />
                <Marquee />
                <Testimonials />
                <Diferencia />
                <Programa />
                <Faq />
                <FinalCta />
                <CalendarSection />
            </main>
            <Footer />
            </div>
            {esLegal && (
                <div
                    className="fixed inset-0 z-[90] overflow-y-auto bg-[#0d0d0d]"
                    data-lenis-prevent
                    data-testid="legal-overlay"
                >
                    {route === "#/privacidad" ? <Privacidad /> : <Terminos />}
                </div>
            )}
        </div>
    );
}
